// Panel.tsx - Reusable panel component with consistent header styling
import type React from "react";

interface PanelProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const Panel: React.FC<PanelProps> = ({
  title,
  children,
  className = "",
}) => {
  return (
    <div className={`panel ${className}`}>
      <div className="panel-header">
        <div className="panel-header-title">
          <span className="panel-header-icon">█</span>
          <span className="panel-header-text">{title}</span>
        </div>
      </div>
      <div className="panel-content">{children}</div>
    </div>
  );
};
